import { render, staticRenderFns } from "./page-unauthorized.vue?vue&type=template&id=7619f0e2&"
import script from "./page-unauthorized.vue?vue&type=script&lang=js&"
export * from "./page-unauthorized.vue?vue&type=script&lang=js&"
import style0 from "./page-unauthorized.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7619f0e2')) {
      api.createRecord('7619f0e2', component.options)
    } else {
      api.reload('7619f0e2', component.options)
    }
    module.hot.accept("./page-unauthorized.vue?vue&type=template&id=7619f0e2&", function () {
      api.rerender('7619f0e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/page-unauthorized/page-unauthorized.vue"
export default component.exports